export const skillsData = [
    {
      label: "FRONT END",
      data: [
        {
          skillName: "HTML",
          percentage: "90",
        },
        {
          skillName: "CSS",
          percentage: "85",
        },
        {
          skillName: "JAVASCRIPT",
          percentage: "80",
        },
         {
          skillName: "REACT",
          percentage: "75",
        },
      ],
    },
    {
      label: "BACK END",
      data: [
        {
          skillName: "NODE.JS",
          percentage: "70",
        },
        {
          skillName: "PYTHON",
          percentage: "65",
        },
        {
          skillName: "JAVA",
          percentage: "60",
        },
        {
          skillName: "C/C++",
          percentage: "50",
        },
      ],
    },
    {
      label: "DATABASES",
      data: [
        {
          skillName: "SQL",
          percentage: "75",
        },
        {
          skillName: "MONGO DB",
          percentage: "70",
        },
      ],
    },
  ];